var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node_status"},[_c('span',{class:[`type${_vm.style}`, 'node_status-value']},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"node_status-text"},[_vm._v(_vm._s(_vm.text))]),_c('i',{class:[`status${_vm.style}`, 'node', 'node_status-status']})])
}
var staticRenderFns = []

export { render, staticRenderFns }